const Navbar = () => {
  return (
    <nav
      data-cy="header-background"
      className="flex items-center justify-center bg-primary max-w-screen h-[64px]  px-[20px] lg:h-[105px]"
    >
      <div className="container max-w-[1000px]">
        <h1
          data-cy="header-title"
          className="flex flex-start text-sans text-white text-[18px] font-[700] lg:text-[24px]"
        >
          TO DO LIST APP
        </h1>
      </div>
    </nav>
  );
};

export default Navbar;
